import style from "../../../../assets/scss/common/modal/leaveModal.module.scss";
import {Fragment, useEffect} from "react";
import {LeaveReason} from "../../../../types/user";
import {useTranslation} from "react-i18next";

interface Args{
    radioOption: LeaveReason;
    setRadioOption: (_: LeaveReason) => void
    radioTextReason: string;
    setRadioTextReason: (_: string) => void
    errorMessage: string;
    setErrorMessage: (_:string) =>void;
}

export function LeaveReasonField(
    {radioOption, setRadioOption, radioTextReason, setRadioTextReason,
        errorMessage, setErrorMessage}: Args) {
    const { t } = useTranslation("userInfo");
    useEffect(() => {
        setRadioTextReason('')
        setErrorMessage('')
        // eslint-disable-next-line
    }, [radioOption]);

    const reasonRadioWrappers = [
        {
            content: t('leave.step2.item1'),
            option: LeaveReason.REMOVE,
            setRadioOption: setRadioOption,
            isEtcStatus: false,
        },
        {
            content: t('leave.step2.item2'),
            option: LeaveReason.INCONVENIENT,
            setRadioOption: setRadioOption,
            isEtcStatus: false,
        },
        {
            content: t('leave.step2.item3'),
            option: LeaveReason.USE_OTHER_SITE,
            setRadioOption: setRadioOption,
            isEtcStatus: false,
        },
        {
            content: t('leave.step2.item4'),
            option: LeaveReason.LOW_USE,
            setRadioOption: setRadioOption,
            isEtcStatus: false,
        },
        {
            content: t('leave.step2.item5'),
            option: LeaveReason.HUGE_PROGRAM,
            setRadioOption: setRadioOption,
            isEtcStatus: false,
        },
        {
            content: t('leave.step2.item6'),
            option: LeaveReason.MANY_ERRORS,
            setRadioOption: setRadioOption,
            isEtcStatus: false,
        },
        {
            content: t('leave.step2.item7'),
            option: LeaveReason.CONTENTS,
            setRadioOption: setRadioOption,
            isEtcStatus: false,
        },
        {
            content: t('leave.step2.item8'),
            option: LeaveReason.PERSONAL_INFORMATION,
            setRadioOption: setRadioOption,
            isEtcStatus: false,
        },
        {
            content: t('leave.step2.item9'),
            option: LeaveReason.SERVICE,
            setRadioOption: setRadioOption,
            isEtcStatus: false,
        },
        {
            content: t('leave.step2.item10'),
            option: LeaveReason.ETC,
            setRadioOption: setRadioOption,
            isEtcStatus: true,
        },
    ];

    return (
        <>
            <div className={style.leaveAgreementWrapper}>
                <div className={style.leaveAgreementContentWrapper}>
                    {reasonRadioWrappers.map((wrapper, index) => (
                        <Fragment key={index}>
                            <div className={style.agreementContent}
                                 onClick={() => {
                                     wrapper.setRadioOption(wrapper.option);
                                 }}>
                                <input
                                    type="radio"
                                    id={`radio${index}`} // 고유한 id를 위해 index 사용
                                    name="agree"
                                    value={wrapper.option}
                                    checked={wrapper.option === radioOption}
                                    className={style.radioButton}
                                    readOnly
                                />
                                <div className={style.agreementTextWrapper}>
                                        <span className={style.agreementText}>
                                            {wrapper.content}
                                        </span>
                                </div>
                            </div>
                            {wrapper.option === LeaveReason.ETC && radioOption === LeaveReason.ETC && (
                                <div className={style.inputWrapper}>
                                    <input
                                        type="radioTextReason"
                                        className={style.contentInput}
                                        value={radioTextReason}
                                        name="radioTextReason"
                                        onChange={(e => setRadioTextReason(e.target.value))}
                                        placeholder={t('leave.step2.placeholder')}
                                    />
                                    <div className={style.inputInline}></div>
                                </div>
                            )}
                        </Fragment>
                    ))}
                    {errorMessage && (
                        <div className={style.errorMessageWrapper}>
                            <span className={style.message}>{errorMessage}</span>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}